import Datetime from "react-datetime";

export default Datetime;
